module.exports = __webpack_public_path__ + "img/challenge_default_img.fdd3ec7c.png";